const CATEGORY_COLORS = [
  'red', 'blue', 'green', 'orange', 'viol',
  'pink', 'cyan', 'yellow', 'purple', 'lime',
  'coral', 'indigo', 'teal', 'magenta', 'amber',
  'emerald', 'rose', 'sky', 'violet', 'mint'
];

const CATEGORY_COLORS_STORAGE_KEY = 'categoryColors';

export function getRandomColor() {
  return CATEGORY_COLORS[Math.floor(Math.random() * CATEGORY_COLORS.length)];
}

export function getCategoryColors() {
  const stored = localStorage.getItem(CATEGORY_COLORS_STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
}

export function setCategoryColors(colors) {
  localStorage.setItem(CATEGORY_COLORS_STORAGE_KEY, JSON.stringify(colors));
}

export function getCategoryColor(categoryId) {
  const colors = getCategoryColors();
  return colors[categoryId] || null;
}

export function assignCategoryColor(categoryId) {
  const colors = getCategoryColors();
  if (!colors[categoryId]) {
    colors[categoryId] = getRandomColor();
    setCategoryColors(colors);
  }
  return colors[categoryId];
}

export function ensureCategoriesHaveColors(categories) {
  const colors = getCategoryColors();
  let hasChanges = false;
  
  categories.forEach(category => {
    if (!colors[category.id]) {
      colors[category.id] = getRandomColor();
      hasChanges = true;
    }
  });
  
  if (hasChanges) {
    setCategoryColors(colors);
  }
  
  return colors;
} 